<template>
    <ui-Airboard :panel="'login'" :openTab="false">
        <template v-slot:body>
            <inline-svg class="logo" :src="getImage('mysair-logo.svg')"></inline-svg>
            <div class="welcome">
                {{ $dicc.recover.title }}
                <p v-if="sended">{{ $dicc.recover.recovered }}</p>
            </div>
            <template v-if="!sended">
                <FormMixinInput :label="$dicc.recover.passChange" property="password" type="password"></FormMixinInput>
                <FormMixinInput
                    :label="$dicc.recover.passChangeConfirmation"
                    property="password_confirmation"
                    type="password"
                ></FormMixinInput>
                <a class="btn btn--simple my-3" @click.stop.prevent="doRecover">{{ $dicc.recover.action }}</a>
            </template>
            <hr />
            <router-link :to="{ name: 'Login' }" class="link mt-2">{{ $dicc.register.loginAction }}</router-link>
        </template>
    </ui-Airboard>
</template>

<script>
    import { FormMixin } from '../mixins/FormMixin';

    export default {
        name: 'Remember',
        mixins: [FormMixin],
        data: function() {
            return {
                sended: false,
            };
        },
        methods: {
            init() {
                this.$set(this, 'model', {
                    password: '',
                    password_confirmation: '',
                });
            },

            doRecover: function() {
                this.loading++;
                this.resetErrors();

                this.$api.recover(
                    { ...this.$route.query, ...this.model },
                    (data) => {
                        this.sended = true;
                    },
                    (error) => this.showError(error),
                    () => this.loading--
                );
            },
        },
    };
</script>
